import { CodeValue } from "./CodeValue";
import { DatePeriodModel } from "./DatePeriodModel";
import { PatientModel } from "./PatientModel";
import { RecordMetadata } from "./RecordMetadata";

class VaccinationRefusalModel {
    public Id: number;
    public Metadata: RecordMetadata;
    public Vaccine: CodeValue;
    public Reason: CodeValue;
    public DatePeriod: DatePeriodModel;
    public Patient: PatientModel;

    constructor(init?: Partial<VaccinationRefusalModel>) {
        Object.assign(this, init);
        this.DatePeriod = new DatePeriodModel({ ...init?.DatePeriod });
    }
}

export { VaccinationRefusalModel };
